

























import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import AudienceCreativeCard from '@ui/cards/AudienceCreativeCard'

settings =
  name: 'AudienceSetList'

  resources:
    audience_sets:
      resourceName: 'audience_set'
      slug: 'audience_sets'

  vue:
    components: {
      LoadingIndicator,
      AudienceCreativeCard,
    }

    methods:
      hiNavToCreateAudienceSet: ->
        @$router.push { name: 'AudienceSetCreatePage' }

export default VueOptions.vue settings
